require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/pages/browse/category.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/pages/browse/category.legacy.js
// module id = 674
// module chunks = 31